import { render, staticRenderFns } from "./CostCentre.vue?vue&type=template&id=54ae0ee9&"
import script from "./CostCentre.vue?vue&type=script&lang=js&"
export * from "./CostCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports